import React from 'react';

const AboutPage = () => (
    <>
    <h1 className="about-banner">About Me</h1>
    <p>
        Thanks for stopping by and getting to know a little bit more about me!
    </p>
    <p>
        I'll be adding some relevant bio stuff here in the near future.
    </p>
    </> 
);

export default AboutPage;